// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"9ce905d2","589":"11df7992"}[chunkId] + ".chunk.js";
};